
const version = '1.0.1'
const deployDate = '09/01/2026'
const dateFormate = 'DD/MM/YYYY'
const tableDateFormate = 'YYYYMMDD'

const translations = {
    it: {
        ProjectName: 'Pista in barca',
        GeofencingAdmin: 'GeoFencing amministrativo',
        Logout: 'Disconnetti',
        map: 'Mappa',
        saveChanges: 'Salva modifiche',
        update: "Aggiornamento",
        cancel: 'Annulla',
        users: "Utenti",
        userSubtitle: "Visualizza, gestisci e naviga nei record dettagliati degli utenti",
        addUser: "Aggiungi Utente",
        updateUser: "Aggiorna Utente",
        editUser: "Modifica Utente",
        userAdded: "Utente aggiunto con successo!",
        userUpdated: "Utente aggiornato con successo!",
        name: "Nome",
        email: "Email",
        role: "Ruolo",
        actions: "Azioni",
        admin: "Amministratore",
        user: "Utente",
        settingHeading: 'Impostazioni',
        profileSetting: 'Profilo',
        securityfleSetting: 'Sicurezza',
        PersonalInfo: 'Informazioni Personali',
        password: "Password",
        newpassword: 'Nuova password',
        pleaseEnterYourNewpassword: 'Per favore, inserisci la tua nuova password!',
        passwordMustBeatleat: 'La password deve essere lunga almeno 8 caratteri!',
        confirlnewpassword: 'Conferma la nuova password',
        pleaseConfirmNewpassword: 'Per favore conferma la tua nuova password!',
        passwordDonotMatch: 'Le password non corrispondono!',
        passwordUpdated: 'Password aggiornata con successo',
        userNameUpdated: 'Nome utente aggiornato con successo',
        pleaseEnterName: 'Per favore inserisci il tuo nome',
        changePasswrdButton: 'Cambia password',
        loading: "Caricamento...",
        devices: "Dispositivi",
        deviceSubtitle: "Gestisci e monitora tutti i tuoi dispositivi collegati",
        deviceList: "Elenco Dispositivi",
        addDevice: "Aggiungi Dispositivo",
        updateDevice: "Aggiorna Dispositivo",
        editDevice: "Modifica Dispositivo",
        searchDevices: "Cerca dispositivi",
        typeOfDevice: "Tipo di Dispositivo",
        deviceName: "Nome del Dispositivo",
        deviceOwner: "Utente",
        macAddress: "Indirizzo MAC",
        serialNumber: "Numero di Serie",
        pleaseEnterTypeOfDevice: "Inserisci il tipo di dispositivo!",
        pleaseEnterSerialNumber: "Per favore inserisci il numero di serie!",
        placeholderEnterDeviceName: "Per favore inserisci il nome del dispositivo!",
        deviceAdded: "Dispositivo aggiunto con successo!",
        deviceUpdated: "Dispositivo aggiornato con successo!",
        deviceDeleted: "Dispositivo eliminato con successo!",
        getPDF: "Scarica PDF",
        organizations: "Organizzazioni",
        organizationSelect: "Seleziona organizzazione",
        phone: "Telefono",
        enterPhone: "Inserisci il numero di telefono",
        phoneReq: "Per favore inserisci il numero di telefono!",
        searchUser: "Cerca utente",
        qualityUser: "Utente Qualità",
        teamTrack: "Tracciamento Squadra",
        selectRole: "Seleziona Ruolo",
        nameReq: "Il nome è obbligatorio!",
        emailReq: "L'email è obbligatoria!",
        passwordReq: "La password è obbligatoria!",
        roleReq: "Il ruolo è obbligatorio!",
        enterName: "Inserisci il nome",
        enterEmail: "Inserisci l'email",
        enterPassword: "Inserisci la password",
        fetchError: "Errore nel caricamento degli utenti",
        addUserError: "Errore durante l'aggiunta dell'utente",
        updateUserError: "Errore durante l'aggiornamento dell'utente",
        roleUpdated: "Ruolo aggiornato con successo!",
        updateRoleError: "Errore nell'aggiornamento del ruolo",
        action: 'Azione',
        deviceDeleted: 'Dispositivo Eliminato correttamente',
        geofencing: "GeoFencing",
        geofencingSubtitle: "Gestisci i perimetri e i confini delle barche",
        searchBoat: "Cerca barca...",
        addGeofencing: "Aggiungi GeoFencing",
        editGeofencing: "Modifica GeoFencing",
        boatName: "Nome della barca",
        enterBoatName: 'Inserisci il nome della barca',
        boatNameReq: "Il nome della barca è obbligatorio",
        routerSerialNo: "Numero di serie del router",
        enterSerialNo: 'Inserisci il numero di serie',
        serialNoReq: "Il numero di serie è obbligatorio",
        boatLogo: "Logo della barca",
        boatLogoReq: "Il logo della barca è obbligatorio",
        onlyImageAllowed: "Sono consentiti solo file immagine",
        fetchLocationFirst: "Per favore, recupera prima la posizione del dispositivo",
        locationFound: "Posizione trovata!",
        locationNotFound: "Posizione non trovata",
        dragMarker: "Trascina il marker per regolare la posizione",
        adjustRadius: "Regola il raggio del perimetro",
        radius: "Raggio",
        deleteConfirm: "Sei sicuro?",
        yes: "Sì",
        no: "No",
        operationSuccess: "Operazione completata con successo",
        operationFailed: "Operazione fallita",
        upload: "Carica",
        longitude: "Longitudine",
        latitude: "Latitudine",
        deviceType: "Seleziona il tipo",
        enterSerialNumber: "Inserisci il numero di serie",
        enterDeviceName: "Inserisci il nome del dispositivo",
        deviceType: "Tipo di Dispositivo",
        online: "In linea",
        offline: "Non in linea",
        status: "Stato",
        createdAt: "Creato il",
        backToList: "Torna all'elenco",
        unableToLoadStream: "Impossibile caricare lo streaming",
        retry: "Riprova",
        camerasList: "Elenco Telecamere",
        hideCamera: "Nascondi telecamera",
        unhideCamera: "Mostra telecamera",
        showHiddenCameras: "Mostra nascoste",
        hideHiddenCameras: "Nascondi le nascoste",
        hiddenTag: "Nascosta",
        cameraHidden: "Telecamera nascosta",
        cameraVisible: "Telecamera visibile",
        cameraVisibilityError: "Impossibile aggiornare la telecamera",
        noVisibleCameras: "Nessuna telecamera visibile",
        camera: "Telecamera",
        capabilitySet: "Set di Funzionalità",
        dvrName: "Nome DVR",
        logoRequired: "Il logo è obbligatorio",
        downloadPDF: "Scarica PDF",
        geofenceList: "Lista geofence",
        loadingMap: "Caricamento mappa...",
        selectBoatName: "Seleziona il nome della barca",
        selectDate: 'Seleziona data',
        noData: 'Nessun dato',
        noSerialNumberFound: 'Nessun numero di serie trovato',
        geofenceAlreadyExists: 'Esiste già una geofence per questo router',
        geofenceAdded: 'Geofence aggiunta con successo',
        failedFetchLiveStream: 'Impossibile recuperare lo streaming live. La telecamera potrebbe essere offline',
        deleteheading: "Eliminare",
        deleteDeviceMessage: "Sei sicuro di voler eliminare questo dispositivo?",
        deleteGeofenceMessage: "Sei sicuro di voler eliminare questa geofence?",
        deleteUserMessage: "Sei sicuro di voler eliminare questa user?",
    },
    
    en: {
        deleteUserMessage: "Are you sure you want to delete this user?",
        deleteGeofenceMessage: "Are you sure you want to delete this geofence?",
        deleteDeviceMessage: "Are you sure you want to delete this device?",
        deleteheading: "Delete",
        selectBoatName: "Select Boat Name",
        loadingMap: "Loading Map...",
        geofenceList: "Geofence List",
        downloadPDF: "Download PDF",
        logoRequired: "Logo is required",
        deviceType: "Device Type",
        online: "Online",
        offline: "Offline",
        status: "Status",
        createdAt: "Created At",
        backToList: "Back to List",
        unableToLoadStream: "Unable to load stream",
        retry: "Retry",
        camerasList: "Cameras List",
        hideCamera: "Hide camera",
        unhideCamera: "Show camera",
        showHiddenCameras: "Show hidden",
        hideHiddenCameras: "Hide hidden",
        hiddenTag: "Hidden",
        cameraHidden: "Camera hidden",
        cameraVisible: "Camera visible",
        cameraVisibilityError: "Could not update camera",
        noVisibleCameras: "No visible cameras",
        camera: "Camera",
        capabilitySet: "Capability Set",
        dvrName: "DVR Name",
        enterDeviceName: "Enter Device name",
        enterSerialNumber: "Enter Serial number",
        deviceType: "Select Type",
        latitude: "Latitude",
        longitude: "Longitude",
        geofencing: "GeoFencing",
        geofencingSubtitle: "Manage boat perimeters and boundaries",
        searchBoat: "Search Boat...",
        addGeofencing: "Add GeoFencing",
        editGeofencing: "Edit GeoFencing",
        boatName: "Boat Name",
        enterBoatName: 'Enter boat name',
        boatNameReq: "Boat name is required",
        routerSerialNo: "Router Serial Number",
        enterSerialNo: 'Enter serial number',
        serialNoReq: "Serial number is required",
        boatLogo: "Boat Logo",
        boatLogoReq: "Boat Logo is required",
        onlyImageAllowed: "Only image files are allowed",
        fetchLocationFirst: "Please fetch device location first",
        locationFound: "Location found!",
        locationNotFound: "Location not found",
        dragMarker: "Drag marker to adjust location",
        adjustRadius: "Adjust Perimeter Radius",
        radius: "Radius",
        deleteConfirm: "Are you sure?",
        yes: "Yes",
        no: "No",
        operationSuccess: "Operation successful",
        operationFailed: "Operation failed",
        upload: "Upload",
        deviceDeleted: 'Device Delete successfully',
        action: 'Action',
        GeofencingAdmin: 'Admin GeoFencing',
        ProjectName: 'Boat Track',
        Logout: 'Logout',
        map: 'Map',
        saveChanges: 'Save Changes',
        update: "Update",
        cancel: 'Cancel',
        users: "Users",
        userSubtitle: "View, manage and navigate to detailed user records",
        addUser: "Add User",
        updateUser: "Update User",
        editUser: "Edit User",
        userAdded: "User added successfully!",
        userUpdated: "User updated successfully!",
        name: "Name",
        email: "Email",
        role: "Role",
        actions: "Actions",
        admin: "Admin",
        user: "User",
        settingHeading: 'Settings',
        profileSetting: 'Profile',
        securityfleSetting: 'Security',
        PersonalInfo: 'Personal Information',
        password: "Password",
        newpassword: 'New Password',
        pleaseEnterYourNewpassword: 'Please enter your new password!',
        passwordMustBeatleat: 'Password must be at least 8 characters!',
        confirlnewpassword: 'Confirm New Password',
        pleaseConfirmNewpassword: 'Please confirm your new password!',
        passwordDonotMatch: 'Passwords do not match!',
        passwordUpdated: 'Password updated successfully',
        userNameUpdated: 'User name updated successfully',
        pleaseEnterName: 'Please enter your name',
        changePasswrdButton: 'Change Password',
        loading: "Loading...",
        devices: "Devices",
        deviceSubtitle: "Manage and monitor all your connected hardware devices",
        deviceList: "Device List",
        addDevice: "Add Device",
        updateDevice: "Update Device",
        editDevice: "Edit Device",
        searchDevices: "Search Devices",
        typeOfDevice: "Device Type",
        deviceName: "Device Name",
        deviceOwner: "User",
        macAddress: "MAC Address",
        serialNumber: "Serial Number",
        pleaseEnterTypeOfDevice: "Please enter type of device!",
        pleaseEnterSerialNumber: "Please enter serial number!",
        placeholderEnterDeviceName: "Please enter device name!",
        deviceAdded: "Device added successfully!",
        deviceUpdated: "Device updated successfully!",
        deviceDeleted: "Device deleted successfully!",
        getPDF: "Get PDF",
        organizations: "Organizations",
        organizationSelect: "Select Organization",
        phone: "Phone",
        enterPhone: "Enter phone number",
        phoneReq: "Please enter phone number!",
        searchUser: "Search User",
        qualityUser: "Quality User",
        teamTrack: "Team Track",
        selectRole: "Select Role",
        nameReq: "Name is required!",
        emailReq: "Email is required!",
        passwordReq: "Password is required!",
        roleReq: "Role is required!",
        enterName: "Enter name",
        enterEmail: "Enter email",
        enterPassword: "Enter password",
        fetchError: "Error fetching users",
        addUserError: "Error adding user",
        updateUserError: "Error updating user",
        roleUpdated: "Role updated successfully!",
        updateRoleError: "Error updating role",
        selectDate: 'Select date',
        noData: 'No data',
        noSerialNumberFound: 'No serial number found',
        geofenceAlreadyExists: 'Geofence already exists for this router',
        geofenceAdded: 'Geofence added successfully',
        failedFetchLiveStream: 'Failed to fetch live stream. Camera might be offline',
    }
}

export {
    translations,
    version,
    deployDate,
    dateFormate,
    tableDateFormate,
}
